import React, {  useEffect } from 'react';
import { useJWTAuth } from '../components/JWTAuthContext.js';
import  ProfileNavigation  from './profile/ProfileNavigation';

const Profile: React.FC = () => {
  const { user, isAuthenticated, logout, isLoading } = useJWTAuth();

  console.log('User Data:', user);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.href = '/login';
    }
  }, [isAuthenticated, isLoading]);

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8f9ff' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading profile...</p>
        </div>
      </div>
    );
  }

  // Redirect if not authenticated (this shouldn't render but just in case)
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9ff', paddingTop: '10px' }}>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-12">
            
            {/* Profile Navigation */}
            <ProfileNavigation className="mb-4" />           
            {/* Main Content */}
            <div className="row">
              <div className="col-lg-6">
                {/* Basic Profile Information */}
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
                  <div className="card-header bg-transparent border-0 p-4">
                    <h4 className="fw-bold mb-0">
                      <i className="fas fa-user me-2 text-primary"></i>
                      Profile Information
                    </h4>
                  </div>
                  <div className="card-body p-4">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-medium">First Name</label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          value={user?.firstName || ''}
                          readOnly
                          style={{ borderRadius: '12px', backgroundColor: '#f8f9ff' }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-medium">Last Name</label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          value={user?.lastName || ''}
                          readOnly
                          style={{ borderRadius: '12px', backgroundColor: '#f8f9ff' }}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label fw-medium">Email Address</label>
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          value={user?.email || ''}
                          readOnly
                          style={{ borderRadius: '12px', backgroundColor: '#f8f9ff' }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-medium">Phone Number</label>
                        <input
                          type="tel"
                          className="form-control form-control-lg"
                          value={user?.phone || '+91 99999 00000'}
                          readOnly
                          style={{ borderRadius: '12px', backgroundColor: '#f8f9ff' }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-medium">Exam Preference</label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          value={user?.examPreference || 'JEE & NEET'}
                          readOnly
                          style={{ borderRadius: '12px', backgroundColor: '#f8f9ff' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                {/* Academic Progress */}
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
                  <div className="card-header bg-transparent border-0 p-4">
                    <h4 className="fw-bold mb-0">
                      <i className="fas fa-chart-line me-2 text-primary"></i>
                      Academic Progress
                    </h4>
                  </div>
                  <div className="card-body p-4">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="text-center p-3 rounded" style={{ backgroundColor: '#667eea15' }}>
                          <i className="fas fa-trophy text-primary fa-2x mb-2"></i>
                          <h3 className="fw-bold mb-1">23</h3>
                          <small className="text-muted">Tests Completed</small>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center p-3 rounded" style={{ backgroundColor: '#28a74515' }}>
                          <i className="fas fa-medal text-success fa-2x mb-2"></i>
                          <h3 className="fw-bold mb-1">#156</h3>
                          <small className="text-muted">Current Rank</small>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center p-3 rounded" style={{ backgroundColor: '#ffc10715' }}>
                          <i className="fas fa-percent text-warning fa-2x mb-2"></i>
                          <h3 className="fw-bold mb-1">78%</h3>
                          <small className="text-muted">Average Score</small>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center p-3 rounded" style={{ backgroundColor: '#dc354515' }}>
                          <i className="fas fa-clock text-danger fa-2x mb-2"></i>
                          <h3 className="fw-bold mb-1">42h</h3>
                          <small className="text-muted">Study Time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Account Settings */}
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
                  <div className="card-header bg-transparent border-0 p-4">
                    <h4 className="fw-bold mb-0">
                      <i className="fas fa-cog me-2 text-primary"></i>
                      Account Settings
                    </h4>
                  </div>
                  <div className="card-body p-4">
                    <div className="d-grid gap-2">
                      
                      <button className="btn btn-outline-secondary btn-lg" style={{ borderRadius: '12px' }}>
                        <i className="fas fa-key me-2"></i>
                        Change Password
                      </button>
                      <button className="btn btn-outline-info btn-lg" style={{ borderRadius: '12px' }}>
                        <i className="fas fa-bell me-2"></i>
                        Notification Settings
                      </button>
                      <hr />
                      <button
                        className="btn btn-outline-danger btn-lg"
                        style={{ borderRadius: '12px' }}
                        onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt me-2"></i>
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
